import { Action, action, Computed, computed } from 'easy-peasy'

export interface UIModel {
  apiRequestCount: number
  apiLoading: Computed<UIModel, boolean>
  increaseApiLoading: Action<UIModel>
  decreaseApiLoading: Action<UIModel>
}

const ui: UIModel = {
  // State
  apiRequestCount: 0,

  // computed
  apiLoading: computed(state => !!state.apiRequestCount),

  // actions
  increaseApiLoading: action(state => {
    state.apiRequestCount = state.apiRequestCount + 1
  }),

  decreaseApiLoading: action(state => {
    state.apiRequestCount = state.apiRequestCount - 1
  })
}

export default ui
